import { Component, computed, input, output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { COMMON_IMPORTS } from '../../../../../../Shared/common-imports';
import { AvTableLoadingBarComponent } from '../../../../../../Shared/Components/loading-bar/table-loading-bar.component';
import { AvTableCopyCellComponent } from '../../../../../../Shared/Components/table-copy-cell/table-copy-cell.component';
import { Licence } from '../../../../../../../Interfaces/api/licences.interface';
import {
    LICENCE_COMPONENT_LABEL_KEYS,
    LICENCE_ROSTER_COLUMNS,
} from '../../../../../../../Consts/licences.const';
import { LicenceComponentType } from '../../../../../../../Types/licence-component-type.type';

@Component({
    selector: 'app-licence-roster-table',
    standalone: true,
    imports: [COMMON_IMPORTS, AvTableLoadingBarComponent, AvTableCopyCellComponent],
    templateUrl: './licence-roster-table.component.html',
    styleUrls: [
        '../../../billing/billing.scss',
        '../../../../../../../../assets/theme/cutom/_av-table.scss',
        './licence-roster-table.component.scss',
    ],
})
export class LicenceRosterTableComponent {
    readonly licences = input<Licence[]>([]);
    readonly isLoading = input<boolean>(false);

    readonly reload = output<void>();
    readonly assign = output<Licence>();
    readonly release = output<Licence>();
    readonly resume = output<Licence>();

    readonly displayedColumns = LICENCE_ROSTER_COLUMNS;

    readonly dataSource = computed(() => new MatTableDataSource<Licence>(this.licences()));

    componentLabelKey(componentType: LicenceComponentType): string {
        return LICENCE_COMPONENT_LABEL_KEYS[componentType];
    }

    isAssignable(licence: Licence): boolean {
        return licence.holder_id === null && licence.component_type === 'seat';
    }
}
